export enum CustomerServiceEnum {
  PRATAMA = '6281296624904',
  GREATDAY = '6281296624867',
}
